import styled from "styled-components";
import {
  MyLiquidityWrapper,
  PoolsInfo,
} from "../../Liquidity/Tabs/Pools/styled";
import { InputContainer } from "../../../../components/Common/Input/styled";
import { ButtonCommon } from "../../../../Layout/styled";

export const CaretArrow = styled.div`
  position: absolute;
  top: 20px;
  right: 10px;
  span {
    transition: all 0.15s linear;
  }
  &.active {
    span {
      transform: rotate(180deg);
    }
  }
`;
export const PoolsListAction = styled.ul`
  display: flex;
  align-items: center;
  gap: 5px;
  &.light {
    & > li {
      border-color: #92929e;
      background-color: #828282;
      box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.25),
        0px 2.25px 0px 0px rgba(255, 255, 255, 0.33) inset;
    }
  }
  & > li {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border-radius: 4.5px;
    border: 0.75px solid #3a3a40;
    background: #43424a;
    box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.25),
      0px 2.25px 0px 0px rgba(186, 186, 186, 0.33) inset;
    figure {
      display: flex;
      width: 12px;
      height: 12px;
    }
  }
`;
export const PoolsStakingHeader = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  &.active {
    padding-bottom: 10px;
  }
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
  }
`;
export const PoolsStakingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  width: calc(100% - 178px);
  @media screen and (min-width: 768px) and (max-width: 900px) {
    width: calc(100% - 70px);
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    flex-wrap: wrap;
    gap: 20px;
  }
`;
export const PoolsStakingDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  ${PoolsInfo} {
    p {
      margin-bottom: 5px;
    }
  }
`;
export const PoolsStats = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 25px;
  width: 100%;
  p {
    width: 33.33%;
  }
  @media screen and (min-width: 768px) and (max-width: 900px) {
    gap: 10px;
  }
  @media screen and (max-width: 767px) {
    gap: 20px;
    width: 100%;
    p {
      font-size: 14px;
    }
  }
`;
export const PoolsStaking = styled.div`
  ${MyLiquidityWrapper} {
    width: 150px;
  }
  @media screen and (min-width: 768px) {
    .ant-table-cell {
      &:last-child {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100% !important;
      }
    }
  }

  @media screen and (min-width: 768px) and (max-width: 900px) {
    ${MyLiquidityWrapper} {
      width: 100px;
    }
  }
  @media screen and (max-width: 767px) {
    ${MyLiquidityWrapper} {
      width: 100%;
    }
    .ant-table-cell {
      &:last-child {
        width: 100% !important;
      }
    }
  }
`;
export const PoolsStakingBottom = styled.div`
  width: 100%;
  border-top: 1px solid transparent;
  padding-top: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.15s linear;
  overflow: hidden;
  height: 0;
  opacity: 0;
  &.active {
    height: 135px;
    padding-top: 15px;
    border-color: #43424a;
    opacity: 1;
  }
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    &.active {
      height: 432px;
    }
  }
`;
export const StakingBottomReward = styled.div`
  min-height: 112px;
  background: url("/assets/images/common/reward_bg.png") no-repeat center /
    cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 30%;
  height: 100%;
  border-radius: 10px;
  & > p {
    &:nth-child(1) {
      font-size: 12px;
      color: #34f497;
      font-weight: 600;
    }
    &:nth-child(2) {
      font-size: 16px;
      color: #f7f7f8;
      font-family: DMMono-500;
    }
  }
  &.light {
    background-color: rgba(189, 189, 189, 0.7);
    & > p {
      &:nth-child(1) {
        color: #000;
      }
      &:nth-child(2) {
        color: red;
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    & > p {
      &:nth-child(2) {
        font-size: 12px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;
    min-height: 70px;
    height: auto;
    & > p {
      &:nth-child(1) {
        font-size: 12px;
      }
      &:nth-child(2) {
        font-size: 14px;
      }
    }
  }
`;
export const StakingBottomForm = styled.div`
  width: 40%;
  border-radius: 10px;
  background: #2b2b2e;
  padding: 10px;
  ${ButtonCommon} {
    margin-top: 10px;
    // padding-top: 8px;
    // padding-bottom: 8px;
    font-size: 12px;
  }
  &.light {
    background-color: transparent;
    border: 1px solid #000;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;
export const FormKib = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #43424a;
  padding-bottom: 10px;
  gap: 10px;
  .anticon-calendar {
    transition: all 0.15s linear;
    &:hover {
      opacity: 0.75;
    }
  }
  & > div {
    &:nth-child(1) {
      p {
        white-space: nowrap;
        font-size: 12px;
      }
    }
    &:nth-child(2) {
      p {
        text-align: right;
        color: #92929e;
        font-family: DMMono-400;
        font-size: 12px;
      }
    }
    ${InputContainer} {
      .ant-input-outlined {
        &:hover {
          border-color: transparent;
        }
      }
      span {
        padding: 0;
      }
      input {
        text-align: right;
        padding: 0;
      }
    }
  }
  @media screen and (max-width: 767px) {
    display: block;
    & > div {
      &:nth-child(1) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
      }
    }
  }
`;
export const WrapperActionStake = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
  @media screen and (max-width: 767px) {
    margin-top: 0;
  }
`;
export const EarnedText = styled.p`
  display: flex;
  align-items: center;
  gap: 5px;
`;
export const FormKibVisual = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: flex-end;
  margin-bottom: 5px;
`;
